import { render, staticRenderFns } from "./RejectSalesDialog.vue?vue&type=template&id=420d65c4&scoped=true&"
import script from "./RejectSalesDialog.vue?vue&type=script&lang=js&"
export * from "./RejectSalesDialog.vue?vue&type=script&lang=js&"
import style0 from "./RejectSalesDialog.vue?vue&type=style&index=0&id=420d65c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420d65c4",
  null
  
)

export default component.exports